import React, { PureComponent } from 'react';
import AboutMe from './AboutMe';
import MyWork from './MyWork/MyWork';

class Main extends PureComponent {
	render() {
		return (<div className="main">
			<AboutMe />
			<MyWork />
		</div>);
	}
}

export default Main;
